import { AppState } from '../../app-state/app-state';

export const getPassLikeCollectionState = (state: AppState) => state.passLikeCollection;
